import React, { PureComponent } from 'react';

import {
  Wrapper,
  PreTitle,
  Title,
  Text,
  ContentContainer
} from '../../components/ui';

import ImageSource from '../../../../../containers/assets/peer-feedback-strength-areas-of-development.png';

class StrengthsAndAreasOfDevelopment extends PureComponent {
  render() {
    return (
      <Wrapper>
        <PreTitle>Skills Assessment</PreTitle>
        <Title>Strengths and Areas of Development</Title>
        <Text>Exploring skills/behaviors that your students might be demonstrating in this team exercise</Text>
        <ContentContainer transparent={true}>
          <img src={ImageSource} alt="Strengths and Areas of Development" />
        </ContentContainer>
      </Wrapper>
    );
  }

}

export default StrengthsAndAreasOfDevelopment;



// WEBPACK FOOTER //
// ./src/instructor/components/peer-feedback/pages/skills-assessment/strengths-and-areas-of-development.js